import React from "react";
import "../styles/main.css";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useAuth } from "../core/AuthContext";
import { useSelector } from "react-redux";
import { hasAnyPermission } from "../core/utils/permissionUtils";
import SemesterSelector from "./SemesterSelector";
import AdminSelector from "./AdminSelector";
import Avatar from "./Avatar";

// ─── Nav links ──────────────────────────────────────────────────────────────
// Same options everywhere, in this order: Home, Events, Open Calls, Departments, Users List, Profile.

const NAV_LINKS = [
  { to: "/main", icon: "mdi:home", label: "Home" },
  { to: "/events-list", icon: "material-symbols:calendar-month-outline", label: "Events" },
  { to: "/opencalls-list", icon: "bxs:megaphone", label: "Open Calls" },
  { to: "/departments-list", icon: "mdi:domain", label: "Departments" },
  { to: "/users-list", icon: "ph:users-three-bold", label: "Users List" },
];

// ─── Component ────────────────────────────────────────────────────────────────

function NavHeader() {
  const { user, isAuthenticated } = useAuth();
  const userProfile = useSelector((state) => state.user.profile);
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return null;
  }

  const profilePath = `/users/${user._id}`;

  return (
    <div className="nav-header-wrapper">
      <header className="main-header">
        <div className="header-nav-grid">
          {NAV_LINKS.map(({ to, icon, label }) => (
            <Link
              key={to}
              to={to}
              className={`header-buttons${location.pathname === to ? " active" : ""}`}
            >
              <Icon icon={icon} className="header-button-icon" />
              <p>{label}</p>
            </Link>
          ))}

          <Link
            to={profilePath}
            className={`header-buttons profile-nav-button${location.pathname === profilePath ? " active" : ""}`}
            aria-label="Profile Page"
          >
            <Avatar user={user} size={24} className="header-button-icon" />
          </Link>
        </div>
      </header>

      <div className="secondary-nav-row">
        {hasAnyPermission(userProfile, ['MANAGE_ACCESS_CONTROL', 'MANAGE_USERS']) && <AdminSelector />}
        <SemesterSelector />
      </div>
    </div>
  );
}

export default NavHeader;
